module.exports = __webpack_public_path__ + "img/full5-min.d01aff57.png";